import { DataValue2 } from "../../features/data-types"
import { O } from "../../features/ui"
import { DynamoUserApi } from "../../services"
import { AttributeMap, useDynamoActions } from "../../services/dynamo"
import { DataType, TableName, TablesData } from "../../tables"
import { define } from "../../utils/typeUtils"

export const useUpdatedValueMigration = () => {
    const dynamoActions = useDynamoActions()

    return (
        companyIds: string[],
        table: TableName,
        propName: string,
        updateValue: (dataType: DataType) => O<DataValue2>
    ) => {
        companyIds.forEach(async companyId => {
            const { getAll, createOrUpdate } = dynamoActions(DynamoUserApi, companyId)
            const { dbTableName } = define(TablesData.get(table))

            const dataTypes = await getAll(dbTableName) as DataType[]
            const updatedDataTypes = dataTypes.map(dataType => {
                const newValue = updateValue(dataType)
                return newValue !== undefined ? {
                    ...dataType,
                    [propName]: newValue
                } : dataType
            }) as AttributeMap[]

            await createOrUpdate(dbTableName, updatedDataTypes)
        })
    }
}
